module.exports = __webpack_public_path__ + "img/ac-logotipo-primary.23c837f3.svg";